import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../utils/UserContext";
import { generateAccessFromPermissions } from "../constants/moduleRouteMap";

const RoleProtectedRoute = () => {
  const location = useLocation();

  const { user } = useContext(UserContext);

  const selectStore = localStorage.getItem("selectedStoreName");

  const access = generateAccessFromPermissions(
    user,
    selectStore !== "Select Store",
  );

  const allowedRoutes = access.routes;

  const currentPath = location.pathname;

  const isAllowed = matchPathWithRules(allowedRoutes, currentPath);

  if (!isAllowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

const pathToRegex = (path) => {
  const regexString = path
    .replace(/:\w+/g, "[^/]+") // Replace dynamic params like :id
    .replace(/\//g, "\\/"); // Escape slashes
  return new RegExp(`^${regexString}(\\/)?$`);
};

const matchPathWithRules = (allowedRoutes, currentPath) => {
  for (const pattern of allowedRoutes) {
    const regex = pathToRegex(pattern);
    if (regex.test(currentPath)) {
      return true;
    }
  }
  return false;
};

export default RoleProtectedRoute;
